var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.589,
    height: 96.692,
    viewBox: "0 0 141.589 96.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_942825",
    "data-name": 942825,
    transform: "translate(-0.023 -23.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_383",
    "data-name": "Grupo 383",
    transform: "translate(0.023 23.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_382",
    "data-name": "Grupo 382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_207",
    "data-name": "Trazado 207",
    d: "M138.846,185.6a2.765,2.765,0,0,0,2.765-2.765V165.162a2.765,2.765,0,0,0-2.765-2.765l-45.939-.011H92.9a21.124,21.124,0,0,0-14.933,6.239L73.647,173l-6.626-6.627a13.505,13.505,0,0,0-9.611-3.982l-54.622,0a2.766,2.766,0,0,0-2.765,2.765v54.813a2.765,2.765,0,0,0,2.765,2.765H27.454a9.645,9.645,0,0,0,9.305,7.056l.094,0c0,.033,0,.067,0,.1a9.668,9.668,0,0,0,9.666,9.669h0l.094,0c0,.032,0,.064,0,.1a9.667,9.667,0,0,0,9.666,9.669h0l.094,0c0,.032,0,.064,0,.1a9.668,9.668,0,0,0,9.666,9.669h0a9.594,9.594,0,0,0,5.895-2.007A9.659,9.659,0,0,0,87.468,249.3l.1,0h0a9.656,9.656,0,0,0,9.66-9.762l.1,0h0a9.656,9.656,0,0,0,9.66-9.762l.1,0h0a9.672,9.672,0,0,0,9.31-7.057h22.442a2.765,2.765,0,0,0,2.765-2.765V204.033a2.765,2.765,0,1,0-5.531,0V217.2h-9.4V168.636a2.767,2.767,0,0,0-.1-.711l9.5,0v14.9A2.766,2.766,0,0,0,138.846,185.6ZM36.759,224.259h0a4.137,4.137,0,0,1-2.924-7.062l5.858-5.855a4.136,4.136,0,1,1,5.849,5.851l-5.857,5.856A4.11,4.11,0,0,1,36.759,224.259Zm9.759,9.762h0a4.137,4.137,0,0,1-2.924-7.062l5.857-5.856a4.109,4.109,0,0,1,2.924-1.211h0A4.111,4.111,0,0,1,55.3,221.1h0a4.141,4.141,0,0,1,0,5.85l-5.858,5.855A4.11,4.11,0,0,1,46.518,234.021Zm6.834,8.551a4.141,4.141,0,0,1,0-5.85l5.858-5.855a4.109,4.109,0,0,1,2.924-1.211h0a4.137,4.137,0,0,1,2.924,7.062L59.2,242.572A4.142,4.142,0,0,1,53.352,242.572Zm16.627,8.746,0,0,0,0-1.014,1.014a4.109,4.109,0,0,1-2.924,1.211h0a4.137,4.137,0,0,1-2.924-7.062l5.858-5.855a4.11,4.11,0,0,1,2.925-1.211h0a4.11,4.11,0,0,1,2.925,1.212h0a4.136,4.136,0,0,1,0,5.85Zm10.753,1a4.141,4.141,0,0,1-4.728.793l2.724-2.724a9.631,9.631,0,0,0,2.283-3.611A4.142,4.142,0,0,1,80.732,252.321Zm29.287-29.277a4.11,4.11,0,0,1-2.924,1.211h0a4.111,4.111,0,0,1-2.925-1.212L86.682,205.554a2.765,2.765,0,1,0-3.911,3.91l17.486,17.489a4.137,4.137,0,0,1-2.926,7.061h0a4.11,4.11,0,0,1-2.925-1.212L76.92,215.313a2.765,2.765,0,1,0-3.911,3.911L90.5,236.712a4.137,4.137,0,0,1-2.925,7.061h0a4.111,4.111,0,0,1-2.925-1.212L79.086,237a2.77,2.77,0,0,0-.424-.347,9.6,9.6,0,0,0-6.765-2.766h0l-.1,0a9.637,9.637,0,0,0-2.823-6.932h0a9.6,9.6,0,0,0-6.835-2.832h0l-.1,0a9.657,9.657,0,0,0-9.659-9.765h0l-.1,0a9.637,9.637,0,0,0-2.823-6.932h0a9.678,9.678,0,0,0-13.672,0l-5.858,5.855A9.607,9.607,0,0,0,27.55,217.2H20.487v-31a2.765,2.765,0,0,0-5.531,0v31h-9.4V167.916l51.856,0a8.011,8.011,0,0,1,5.7,2.362l6.65,6.651-5.568,5.636a10.01,10.01,0,0,0,12.264,15.624l9.11-5.455,24.454,24.456a4.1,4.1,0,0,1,1.183,2.46,2.8,2.8,0,0,0-.019.31,2.767,2.767,0,0,0,.034.412A4.1,4.1,0,0,1,110.019,223.044Zm11.129-54.408V217.2h-4.835a9.623,9.623,0,0,0-2.382-3.915L90.458,189.808l3.573-2.14h17.842a2.765,2.765,0,1,0,0-5.531H93.267a2.765,2.765,0,0,0-1.421.393L73.614,193.448a4.48,4.48,0,0,1-5.488-6.992L81.9,172.512a15.558,15.558,0,0,1,11-4.6h0l28.337.007A2.762,2.762,0,0,0,121.148,168.636Z",
    transform: "translate(-0.023 -162.386)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    transform: "translate(136.081 72.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_384",
    "data-name": "Grupo 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_208",
    "data-name": "Trazado 208",
    d: "M496.7,262.287a2.763,2.763,0,1,0,.81,1.955A2.786,2.786,0,0,0,496.7,262.287Z",
    transform: "translate(-491.981 -261.477)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(14.956 55.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_209",
    "data-name": "Trazado 209",
    d: "M58.739,201.792a2.763,2.763,0,1,0,.81,1.955A2.786,2.786,0,0,0,58.739,201.792Z",
    transform: "translate(-54.019 -200.982)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05);
export default __webpack_public_path__ + "static/media/05.4e5702941c41515a7fe1598defdf57bc.svg";
export { ForwardRef as ReactComponent };